var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.show,"no-fade":_vm.noFade,"variant":_vm.isDark ? 'transparent' : 'transparent',"rounded":_vm.rounded}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }